module.exports = __webpack_public_path__ + "fonts/GothamSSm-BookItalic.d50b6017.ttf";